import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import Link from 'component/link.component';
import Button from 'component/button.component';
import OpacityModal from 'component/opacity.modal.component';
import { subscribeNewsletter } from 'store/action/newsletter.action';

class NewsletterModal extends PureComponent {
  render() {
    const { user, customStyle } = this.props;

    return (
      <div>
        <Button
          onClick={() => this._newsletterModal && this._newsletterModal._show()}
          text="Newsletter"
          style={customStyle}
        />

        <OpacityModal
          modalRef={ref => (this._newsletterModal = ref)}
          title="Deseja se inscrever na Newsletter?"
          containerStyle={{ padding: '20px 0', maxWidth: '80%' }}
        >
          {!user ? (
            <p style={{ margin: 15 }}>
              Por favor, faça o login para se inscrever na Newsletter.
            </p>
          ) : (
            <div className="flex-column">
              <span style={{ margin: 20, marginBottom: 0 }}>
                Você receberá nossas publicações mensalmente por e-mail.
              </span>
              <div className="flex-row justify-end" style={{ maxWidth: 450 }}>
                <Button
                  className="component-focus self-align-center"
                  onClick={() => this.onOkBtn()}
                  text="Sim"
                  style={{
                    backgroundColor: '#185335',
                    margin: '20px 20px 0 10px',
                    padding: '8px 15px',
                  }}
                />
                <Link
                  className=" self-align-center"
                  onClick={() => {
                    this.setState({}, this._newsletterModal._hide);
                  }}
                  text="Não"
                  style={{ color: 'black', margin: '20px 15px 0' }}
                />
              </div>
            </div>
          )}
        </OpacityModal>
      </div>
    );
  }

  onOkBtn = e => {
    subscribeNewsletter();

    this.setState({}, this._newsletterModal._hide);
  };
}

function mapStateToProps({ user }) {
  return {
    user,
  };
}

export default connect(
  mapStateToProps,
  null
)(NewsletterModal);
